import { dateFormat } from "shared/util"

import { Box, Divider, Link, Stack, StackProps, Typography } from "@mui/material"
import { MarkdownPreview } from "components/controls/markDownPreview"

import { NotificationLogoImage, OpenNotificationLogoImage } from "./logoImage"
import { NotificationCategoryChip } from "./categoryChip"
import { NotificationResult } from "interface/notification"

type NotificationDetailProps = {
	domain?: string
	notification: NotificationResult
} & StackProps
export const NotificationDetail = ({
	domain,
	notification,
	...others
}: NotificationDetailProps) => (
	<Stack spacing={2} {...others}>
		{domain ? (
			<OpenNotificationLogoImage
				domain={domain}
				notification={notification}
				style={{ maxHeight: "15rem" }}
			/>
		) : (
			<NotificationLogoImage
				notification={notification}
				style={{ maxHeight: "15rem" }}
			/>
		)}
		<Stack direction='row' spacing={1} paddingX={2} alignItems='center'>
			<NotificationCategoryChip category={notification.category}/>
			<Typography variant="body1">{notification.title}</Typography>
			<Box flexGrow={1}/>
			<Typography variant="body2" color='text.secondary'>{dateFormat(notification.updateTime)}</Typography>
		</Stack>

		<Divider/>

		{notification.url ? (
			<>
				<Box textAlign="right" paddingX={2}>
					<Link href={notification.url} target="_blank" rel="noopener" underline='hover'>{notification.url}</Link>
				</Box>
				<Divider/>
			</>
		) : <></>}

		<MarkdownPreview value={notification.description}/>

		<Divider/>
	</Stack>
)
